import SitePageLayout from '../components/SitePageLayout';

export default function PrivacyPolicyScreen() {
  return (
    <SitePageLayout title="Privacy Policy" effectiveDate="February 16, 2026">
      <p>
        Pratikay (the "App") is a product of Xerratus, LLC ("Company," "we," "us," or "our").
        The App helps people practice speaking other languages through partner conversations,
        custom personas, translation support, phonetics, and audio playback. This Privacy Policy
        explains what we collect, how we use it, and your choices.
      </p>
      <p>By using Pratikay, you agree to this Privacy Policy.</p>

      <section className="legal-section">
        <h2>1. Information We Collect</h2>
        <p>We may collect:</p>
        <ul>
          <li>
            Account/profile data: information you provide such as display name, email,
            username, selected languages, and account settings.
          </li>
          <li>
            Conversation/practice data: custom dialogs, partner conversation records, and
            generated practice content.
          </li>
          <li>
            Partner relationship data: partner requests, accepted/rejected status, and unlink
            actions.
          </li>
          <li>
            Purchase and entitlement data: subscription status and one-time top-off pack status.
          </li>
          <li>
            General analytics and diagnostics: aggregate usage and technical logs to improve
            performance and reliability.
          </li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>2. How We Use Information</h2>
        <p>We use data to:</p>
        <ul>
          <li>
            Provide core app functionality (conversation practice, translation, phonetics, and
            audio playback).
          </li>
          <li>Enable partner flows (invite, accept/reject, unlink).</li>
          <li>Manage subscriptions and credit packs.</li>
          <li>Improve app stability, quality, and performance.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>3. AI Processing and Third-Party Sharing</h2>
        <p>
          Pratikay uses OpenAI to provide AI-powered features, including translation, phonetics,
          AI-generated replies, and related audio generation workflows.
        </p>
        <p>To generate these features, we may send:</p>
        <ul>
          <li>Dialog text and speaker turns you submit in conversations.</li>
          <li>Selected target languages and tone/voice preferences used for generation.</li>
          <li>Minimal request metadata needed to process and troubleshoot requests.</li>
        </ul>
        <p>
          We do not send personally identifying information in AI generation requests.
        </p>
        <p>
          During onboarding, we ask for your consent before first use of AI processing. You can
          change this choice later in Settings. If AI processing is disabled, AI-dependent features
          may not work.
        </p>
      </section>

      <section className="legal-section">
        <h2>4. Ads and Cross-App Tracking</h2>
        <ul>
          <li>We do not show third-party ads.</li>
          <li>We do not track users across other apps/websites for advertising.</li>
          <li>We use only general product analytics and diagnostics.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>5. Partner Controls</h2>
        <ul>
          <li>Users must explicitly invite partners.</li>
          <li>Invited users can accept or reject requests.</li>
          <li>Partner conversations can be unlinked by partners.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>6. Purchases</h2>
        <p>Pratikay offers:</p>
        <ul>
          <li>Auto-renewable subscriptions</li>
          <li>One-time top-off credit packs</li>
        </ul>
        <p>Purchases and billing are processed through Apple App Store and Google Play.</p>
      </section>

      <section className="legal-section">
        <h2>7. Data Sharing</h2>
        <p>
          We do not sell personal data. We may use service providers that process data on our
          behalf to host and operate the App, including third-party AI service providers for
          AI-powered features.
        </p>
      </section>

      <section className="legal-section">
        <h2>8. Data Retention</h2>
        <p>
          We retain data only as needed to provide the service, maintain security, resolve
          disputes, and comply with legal obligations.
        </p>
      </section>

      <section className="legal-section">
        <h2>9. Security</h2>
        <p>
          We use reasonable technical and organizational safeguards, but no system is completely
          secure.
        </p>
      </section>

      <section className="legal-section">
        <h2>10. Children</h2>
        <p>
          Pratikay is not directed to children under 13 (or the minimum age required by local
          law).
        </p>
      </section>

      <section className="legal-section">
        <h2>11. Changes to This Policy</h2>
        <p>
          We may update this policy from time to time and will update the date above when we do.
        </p>
      </section>

      <section className="legal-section">
        <h2>12. Contact</h2>
        <p>For privacy questions: privacy@xerratus.com</p>
      </section>
    </SitePageLayout>
  );
}
